import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";
import MainTitleImg1En from "../../../../assets/images/main_title_img1_en.png";
import MainTitleImg1Ru from "../../../../assets/images/main_title_img1_ru.png";
import MainTitleImg2En from "../../../../assets/images/main_title_img2_en.png";
import MainTitleImg2Ru from "../../../../assets/images/main_title_img2_ru.png";
import MainTitleImgMEn from "../../../../assets/images/main_title_img_m_en.png";
import MainTitleImgMRu from "../../../../assets/images/main_title_img_m_ru.png";

export default function SectionMainTitle() {
  const { t, i18n } = useTranslation();

  return (
    <section className="section-main-title">
      <div className="section-main-title__container">
        <div className="section-main-title__wrapper">
          <div className="eclipse eclipse-main-1"></div>
          <div className="eclipse eclipse-main-2"></div>
          <div className="section-main-title__title-wrapper">
            <img
              src={i18n.language == "ru" ? MainTitleImg1Ru : MainTitleImg1En}
              className="d-md-none"
            />
            <div className="section-main-title__title-inner-wrapper">
              <div
                className="section-main-title__title neon-text"
                data-text={t("section_main_title.project_title")}
              >
                {t("section_main_title.project_title")}
              </div>

              <h2>
                <p>{t("section_main_title.project_subtitle1")}</p>
                <p>{t("section_main_title.project_subtitle2")}</p>
              </h2>
            </div>
            <img
              src={i18n.language == "ru" ? MainTitleImg2Ru : MainTitleImg2En}
              className="d-md-none"
            />
          </div>
          <img
            src={i18n.language == "ru" ? MainTitleImgMRu : MainTitleImgMEn}
            className="d-none d-md-block center main-title-img-m"
          />
          <div
            className="section-main-title__age-restriction neon-text"
            data-text="18+"
          >
            18+
          </div>
        </div>
      </div>
    </section>
  );
}
